import React, {Fragment} from "react";
import "@sendbird/uikit-react/dist/index.css";
import {Channel as SBConversation, SendBirdProvider as SBProvider} from "@sendbird/uikit-react";
import UserSessionService from "../../services/UserSessionService";
import ChatUserService from "../../services/chat/ChatUserService";
import ChatConversationService from "../../services/chat/ChatConversationService";
import LoadingSpinnerComponent from "../../components/LoadingSpinnerComponent";
import ToastHelper from "../../utils/ToastHelper";
import TransactionService from "../../services/TransactionService";
import CustomerService from "../../services/CustomerService";
import {Button, Modal, Row} from "reactstrap";
import CreateObjectRowWithLabelComponent from "../../components/CreateObjectRowWithLabelComponent";
import CreateObjectLabel from "../../components/CreateObjectLabel";
import {withRouter} from "react-router-dom";
import ChatMessagesHistoryView from "../../components/chat/ChatMessagesHistoryView";
import {ModalBody} from "react-bootstrap";

const REGISTRATION = "REGISTRATION_ID";
const TRANSACTION = "OUTBOUND_TRANSACTION_ID";

class ChatSingle extends React.Component {

    constructor(props) {
        super(props);

        this.conversationId = this.props.match.params.conversationId
        this.apiUser = UserSessionService.getUser().user;

        this.state = {
            isLoading: true,
            APP_ID: process.env.REACT_APP_SENDBIRD_APP_ID,
            chatUser: null,
            chatResource: null,
            shouldRenderChatDetails: false
        }
    }

    componentDidMount() {
        this.props.changeHeader('Chat');
        this.loadData();
    }

    scrollToBottom() {
        if (this.bottomOfPage) {
            this.bottomOfPage.scrollIntoView({behavior: "smooth"});
        }
    }

    loadData() {
        let newState = {};
        newState.isLoading = false;
        let promiseArr = [];

        let chatUserIndex = promiseArr.length;
        promiseArr[chatUserIndex] = ChatUserService.retrieve(this.apiUser.id);

        let chatConversationIndex = promiseArr.length;
        promiseArr[chatConversationIndex] = ChatConversationService.retrieveConversation(this.conversationId);

        Promise.all(promiseArr).then(response => {

            let chatUser = response[chatUserIndex];
            let chatConversation = response[chatConversationIndex];

            if (chatUser.id) {
                newState.chatUser = chatUser;
            } else {
                ToastHelper.formatError(chatUser);
                this.onBackClick();
                return;
            }

            if (chatConversation.id) {
                newState.canSendMessages = chatConversation.status === "OPEN";
                newState.gotSelectedConversation = true;
                newState.selectedConversation = chatConversation;
                newState.resourceType = chatConversation.context[0].resourceType;
                newState.chatStatus = chatConversation.status;
            } else {
                ToastHelper.formatError(chatConversation);
                this.onBackClick();
                return;
            }

            let secondPromiseArr = [];
            let resourceIndex = secondPromiseArr.length;
            let context = chatConversation.context;

            if (context[0].resourceType === REGISTRATION) {
                secondPromiseArr[resourceIndex] = CustomerService.retrieveCustomerByRegistrationId(context[0].resourceId);
            } else {
                secondPromiseArr[resourceIndex] = TransactionService.retrieveTransactionByTransactionId(context[0].resourceId);
            }

            if (secondPromiseArr.length > 0) {
                Promise.all(secondPromiseArr).then(
                    secondResponse => {

                        let chatResource = secondResponse[resourceIndex];

                        if (chatResource.registrationId) {
                            newState.chatResource = chatResource;
                        } else {
                            ToastHelper.formatError(chatResource);
                            this.onBackClick();
                            return;
                        }

                        this.setState(newState, this.scrollToBottom)
                    })
            } else {
                this.setState(newState)
            }
        })
    }

    createDetail(label, value) {
        return <Fragment>
            <CreateObjectRowWithLabelComponent label={label} className={"float-md-left"} style={{fontSize: "14pt"}}>
                <CreateObjectLabel style={{padding: "0"}}>{value}</CreateObjectLabel>
            </CreateObjectRowWithLabelComponent>
        </Fragment>
    }

    onBackClick() {
        this.props.history.goBack();
    }

    renderConversationHistory() {
        return <Fragment>
            <ChatMessagesHistoryView
                conversation={this.state.selectedConversation}
            />
        </Fragment>
    }

    render() {
        if (this.state.isLoading) {
            return <LoadingSpinnerComponent/>
        }


        return <Fragment key={this.conversationId}>
            <Row>
                <div style={{display: "flex", flex: "6", paddingLeft: "15px", paddingRight: "15px"}}>
                    <Button onClick={this.onBackClick.bind(this)} className={"fa fa-arrow-left"}
                            style={{
                                color: "#222c3d",
                                backgroundColor: "transparent",
                                backgroundRepeat: "no-repeat",
                                border: "none",
                                cursor: "pointer",
                                overflow: "hidden",
                                outline: "none",
                                fontSize: "20pt",
                                textAlign: "left",
                                flex: "1"
                            }}
                    />
                    <div style={{flex: "4", fontWeight: "bold", textAlign: "left", margin: "auto"}}>
                        {this.state.selectedConversation.name}
                    </div>
                    <div style={{margin: "auto", flex: 1}}>
                        <Button
                            className={'btn btn-primary'}
                            onClick={() => {
                                this.setState({shouldRenderChatDetails: true})
                            }}>
                            Info
                        </Button>
                    </div>
                </div>
            </Row>

            {this.renderConversationDetails()}

            {this.state.canSendMessages && this.renderSendbirdConversation()}
            {!this.state.canSendMessages && this.renderConversationHistory()}

        </Fragment>
    }

    renderConversationDetails() {
        //TODO Add Modal class to change header color to "#222c3d"
        return <Modal isOpen={this.state.shouldRenderChatDetails}>
            <div className={'modal-header'} style={{backgroundColor: "#222c3d", color: "white"}}>
                <div className={'modal-title'}>
                    <h5>More Information</h5>
                </div>
                <i className={"fa fa-times"}
                   style={{color: "white", fontWeight: "bold", float: 'right'}}
                   onClick={() => {
                       this.setState({shouldRenderChatDetails: false})
                   }}
                />
            </div>
            <ModalBody>
                {this.createDetail("Conversation Name", this.state.selectedConversation.name)}
                {this.createDetail("Date Created", this.state.selectedConversation.dateCreated)}
                {
                    this.state.resourceType === REGISTRATION &&
                    <Fragment>
                        {this.createDetail("Customer", this.state.chatResource.fullName)}
                        {this.createDetail("Customer Cellphone", this.state.chatResource.msisdnValue)}
                        {this.createDetail("Registration Status", this.state.chatResource.approvalStatus)}
                    </Fragment>
                }
                {
                    this.state.resourceType === TRANSACTION &&
                    <Fragment>
                        {this.createDetail("Customer", this.state.chatResource.customerFullName)}
                        {this.createDetail("Customer Cellphone", this.state.chatResource.customerMsisdn)}
                        {this.createDetail("Transaction Status", this.state.chatResource.status)}
                    </Fragment>
                }
            </ModalBody>
        </Modal>
    }

    renderSendbirdConversation() {
        return <Fragment>
            <hr/>
            <div style={{
                maxHeight: "500px",
                width: '100w',
                overflow: "scroll",
                boxShadow: "rgb(136, 136, 136) 1px 1px 5px",
                borderRadius: "20px"
            }}>
                <SBProvider
                    appId={this.state.APP_ID}
                    userId={this.state.chatUser.sendbirdUserId}
                    nickname={this.state.chatUser.nickname}
                >
                    <SBConversation
                        channelUrl={this.state.selectedConversation.sendbirdUrl}
                        useMessageGrouping={false}
                        useReaction={false}
                    />

                </SBProvider>
            </div>
        </Fragment>
    }
}


export default withRouter(ChatSingle)